import { EventCodes } from '../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.WizardController', [
	'$scope',
	'$element',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.SolutionBuilderAgent.WizardService',
	'mx.SolutionBuilderAgent.ConcurrencyTrackingService',
	'mx.shell.NotificationService',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.shell.ActionManagerService',
	function wizardController(
		$scope,
		$element,
		i18n,
		eventService,
		wizardService,
		concurrencyTrackingService,
		notificationService,
		sidePanelService,
		dialogOpenerService,
		schemaService,
		actionManagerService
	) {
		const vm = this;

		vm.$onInit = function () {
			if (!vm.wizard.pages) {
				throw new Error(i18n.get('solutionBuilderAgent.errors.no_wizard_pages_designed'));
			}

			vm.dataModel.Context.ObjectIds.forEach(function (id) {
				vm.wizard.id += ':' + id;
			});

			vm.subscriptions = [];

			if (!vm.dataModel.ServiceOperation && !vm.dataModel.DataDefinition && vm.wizard.wizardMode === mx.SolutionBuilderAgent.WizardMode.Edit) {
				vm.wizard.wrapView = vm.view;
				vm.subscriptions.push(subscribeConcurrency());

				const eventSidePanelViewClosed = eventService.subscribeTo(
					mx.shell.EventCodes.SidePanelViewClosed,
					function (eventObj, view) {
						if (view === vm.view) {
							unsubscribeFromEvents();
						}
					},
					$scope
				);
				vm.subscriptions.push(eventSidePanelViewClosed);

				vm.subscriptions.push(
					eventService.subscribeTo(
						mx.shell.EventCodes.WizardClose,
						function (e, { wizard, canceled }) {
							if (vm.wizard === wizard) {
								trackTelemetry(canceled ? `{viewName} cancelled` : '{viewName} executed');
							}
						},
						$scope
					)
				);

				$element.on('$destroy', function () {
					unsubscribeFromEvents();
					$scope.$destroy();
				});
			}

			if (vm.view.ShowAsWizard !== true) {
				// regular wizard (not dialog)
				actionManagerService.getActionById(vm.view.actionId).then(function (action) {
					const actionTitle = action ? action.title : vm.wizard.name;
					vm.view.displayName = vm.wizard.contextDescription
						? i18n.getFormatted('shell.wizard.headerTemplate', actionTitle, vm.wizard.contextDescription)
						: i18n.getFormatted('shell.wizard.emptyHeaderTemplate', actionTitle);
				});
			}

			initWizardContextDescriptionHandlers();

			const objectDataDeleted = eventService.subscribeTo(
				mx.SolutionBuilderAgent.Events.ObjectDataDeleted,
				function (eventObj, data) {
					if (data && Array.isArray(data.affectedObjectIds)) {
						const objectId = vm.objectId.toLowerCase();
						const closeCurrentView = data.affectedObjectIds.some((value) => objectId === value.toLowerCase());

						if (closeCurrentView) {
							closeWizard(vm.view, true);
						}
					}
				},
				$scope
			);
			vm.subscriptions.push(objectDataDeleted);
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ViewDataLoaded, vm.view);
		};

		return vm;

		function trackTelemetry(eventName) {
			eventService.dispatchEvent(EventCodes.TrackViewTelemetry, { eventName: eventName, view: vm.view });
		}

		function initWizardContextDescriptionHandlers() {
			if (vm.wizard.wizardMode === mx.SolutionBuilderAgent.WizardMode.Default && vm.dataModel.Context.ObjectIds.length > 0) {
				const singleObject = vm.dataModel.Context.ObjectIds.length === 1;
				if (singleObject) {
					vm.wizard.displayContextFn = function () {
						const objectDetails = {
							EntityType: vm.dataModel.Context.Object.Type,
							ObjectId: vm.dataModel.Context.Object._id,
						};
						dialogOpenerService.openPreview(objectDetails, undefined, undefined, vm.view);
					};
				} else {
					schemaService.getType(vm.dataModel.Context.Object.Type).then(function (objectDetails) {
						vm.wizard.displayContextFn = function () {
							dialogOpenerService
								.openObjectsListPreview(
									{
										entityClassName: objectDetails.MainClassName,
										label: objectDetails.DisplayName,
										selectedItemIds: vm.dataModel.Context.ObjectIds,
									},
									vm.view
								)
								.catch(mx.logCatch);
						};
					});
				}
			}
		}

		function getDisplayName() {
			return vm.wizard.wrapView.name;
		}

		function subscribeConcurrency() {
			return concurrencyTrackingService.subscribe(vm.wizard.context.objectId, {
				change: function (objectId, userId, username) {
					const entity = vm.dataModel[vm.dataModel.entityName];
					wizardService.showObjectChangedNotification(username, entity, vm.dataModel.entityName, vm.widgetId, entity.$$initialEntity, vm.wizard);
				},
				delete: function (objectId, userId, username) {
					wizardService.showObjectDeletedNotification(username, vm.wizard);
				},
				subscribe: function (userName) {
					notificationService.info(
						i18n.getFormatted(
							'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscribed',
							userName || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
							getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
						)
					);
				},
				unsubscribe: function (userName) {
					notificationService.info(
						i18n.getFormatted(
							'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnsubscribed',
							userName || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
							getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
						)
					);
				},
				exist: function (userNames) {
					const msg =
						userNames.length === 1
							? i18n.getFormatted(
									'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscriptionExist',
									userNames[0] || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
									getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
							  )
							: i18n.getFormatted(
									'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscriptionsExist',
									userNames.length,
									getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
							  );

					notificationService.info(msg);
				},
			});
		}

		function unsubscribeFromEvents() {
			vm.subscriptions.forEach(function (unsubscribe) {
				if (unsubscribe) {
					unsubscribe();
				}
			});
			vm.subscriptions = [];
		}

		function closeWizard(view) {
			if (view) {
				unsubscribeFromEvents();
				sidePanelService.closeView(view);
			}
		}
	},
]);
